import { render, staticRenderFns } from "./DisputeOrderModal.vue?vue&type=template&id=d1eb642a&scoped=true&"
import script from "./DisputeOrderModal.vue?vue&type=script&lang=js&"
export * from "./DisputeOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1eb642a",
  null
  
)

export default component.exports